export default "__VITE_ASSET__98528bab__"